<ng-container breakpoint #ref="value">
  <div class="navbar__content justify-content-start" id="navbar-content" [ngClass]="{ 'ps-0': ref.isMobile }">
    <button
      class="btn btn-ghost btn-neutral btn-lg ti-menu ms-2"
      [attr.data-bs-toggle]="(ref.isSmallerThan('sm') | async) ? 'offcanvas' : null"
      data-bs-target="#offcanvasWithBothOptions"
      aria-controls="offcanvasWithBothOptions"
      *ngIf="ref.isSmallerThan('sm') | async"
    >
    </button>
    <div class="navbar__content-search" *ngIf="(ref.isLargerThan('xs') | async) || searchOpen">
      <tbtk-search
        [isMobile]="true"
        [value]="value"
        [modalId]="modalId"
        (onChange)="onChange.emit($event)"
        (onBlur)="onBlur.emit($event)"
        (onFocus)="onFocus.emit($event)"
        (onEnter)="onEnter.emit($event)"
        (onClick)="onClick.emit($event)"
      >
        <ng-content detailSearch select="[detailSearch]"></ng-content>
      </tbtk-search>
    </div>
    <button
      *ngIf="ref.isSmallerThan('sm') | async"
      (click)="handleButtonOpenSearch()"
      class="btn btn-ghost btn-neutral btn-md btn-search-activate ti-lg"
      [ngClass]="{ 'ti-close': searchOpen, 'ti-search': !searchOpen }"
    >
    </button>
    <div class="navbar__content-actions">
      <ng-content select="[right]"></ng-content>
      <ng-content select="tbtk-profile"></ng-content>
    </div>
  </div>
</ng-container>
